import { render, staticRenderFns } from "./IncomeOfTheDay.vue?vue&type=template&id=15895187&"
import script from "./IncomeOfTheDay.vue?vue&type=script&lang=js&"
export * from "./IncomeOfTheDay.vue?vue&type=script&lang=js&"
import style0 from "./IncomeOfTheDay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports